export default "/COLLAB.0cb192ca04a4ec94a7998264f6b3d129.svg";